<pop-settings-box labelKey="DATA_MANAGEMENT.SELECT_ESTIMATE">
  <div>
    <pop-estimate-picker class="project-import"
                         [(selectedEstimate)]="selectedEstimate"
                         [estimateFilter]="filterEstimates"
                         styleClass="rem-fix">
    </pop-estimate-picker>
    <div *ngIf="selectedEstimate"
         class="link">
      <a [routerLink]="getEstimateRoute(selectedEstimate.id)">{{ selectedEstimate.projectCode }}</a>
    </div>
  </div>
</pop-settings-box>

<button class="pop-button"
        [disabled]="!selectedEstimate"
        translate="DATA_MANAGEMENT.EXPORT_TO_GP_SIFIA"
        (click)="exportToGpSifia()">
</button>

<div *ngFor="let result of resultsList">
  <div class="box box-success">
    <div>
      <a [routerLink]="result.routerLink">{{ result.referenceCode }}</a>
      <span [translate]="result.titleKey"></span>
    </div>
  </div>
</div>
